const LiveshowChatTokens = require('liveshow-chat-tokens');

const CHARS_MESSAGE_LIMIT = 1000;

module.exports = (fox, _) => ({
	getChatUserId() {
		return this.rwom1('@root #uchatctrl').userId;
	},

	connectToChat() {
		const chatctrl = this.rwom1('@root #uchatctrl');
		const roomAlias = this.getRoomAlias();
		const ft = this.rwom1('#sidebarMain #tabFans');
		const chatUserId = this.getChatUserId();

		if (this._chatConnectionStates[roomAlias] === chatUserId)
			return fox.Promise.resolve(roomAlias);

		const joinPromise = chatctrl.joinRoom(roomAlias);

		return joinPromise.then(() => {
			this._chatConnectionStates = { [roomAlias]: chatUserId };

			ft.addUser({
				uid: fox.getEnv('site.clientId'),
				name: fox.getEnv('site.alias'),
				isBroadcaster: true
			});

			ft.setCurrentRoom(roomAlias).getUsers();

			chatctrl.getRoomHistory(roomAlias).then(list => {
				const cl = this.rwom1('#sidebarMain #tabChat');
				const mId = fox.getEnv('site.clientId');

				if (list.length > 0)
					cl.addMessage(cl.prepareList(list, mId));
			});

			return roomAlias;
		});
	},

	sendMessageToModel(msg) {
		const uctrl = this.rwom1('@root #uchatctrl');
		const to = [fox.getEnv('site.clientId'), 'web'].join('@');

		if (fox.isEmpty(msg))
			return false;

		msg.name = this.getMemberInfo('login');

		return uctrl.sendMessage(msg, to);
	},

	/* duplacate modifier html */
	_escape(obj, params) {
		const tags = ['script', 'html'];
		const attrs = [
			'onclick', 'onchange', 'onclose', 'oncontextmenu',
			'ondblclick', 'ondrag', 'ondragend', 'ondragenter', 'ondragexit',
			'ondragleave', 'ondragover', 'ondragstart', 'ondrop', 'onfocus',
			'onblur', 'oninput', 'oninvalid', 'onload', 'onkeydown', 'onkeypress', 'onkeyup',
			'onmousedown', 'onmouseenter', 'onmouseleave', 'onmousemove', 'onmouseout', 'onmouseover',
			'onmouseup', 'onmousewheel', 'onscroll', 'onsubmit', 'onsuspend'
		].join('|');

		if (!fox.isString(obj))
			return obj;

		const tagsJoined = (fox.isArray(params) && params || []).reduce(function (_tags, param) {
			return !fox.inArray(_tags, param) ? _tags.concat(param) : _tags;
		}, tags).join('|');

		const tagsRegexp = new RegExp('\<(' + tagsJoined + ')+[^>]*>([^<]*(\<\/(' + tagsJoined + '))?>)?', 'mgi');
		const attrsRegexp = new RegExp('\\s+(' + attrs + ')+="[^"]+"', 'mgi');

		return obj
			.replace(tagsRegexp, '')
			.replace(attrsRegexp, '');
	},

	sendMessageToChat(el, alias, performer) {
		const text = this._escape(
			fox.trim($(performer.dom1('#message-body')).val()),
			'iframe:frame:video:audio:img:image:picture:form:input:textarea:button:canvas:select:object:option:legend:progress:meter:keygen:embed:body:style:link'.split(':')
		).slice(0, CHARS_MESSAGE_LIMIT);
		const msg = {
			text: text,
			name: this.getMemberInfo('login'),
			own: this.getMemberInfo('id')
		};

		if (!text || this.blockedViewer === true)
			return false;

		this.setChatMessage(msg)
			.rwom1('@root #uchatctrl').sendMessage(msg, this.getRoomAlias());

		$(performer.dom1('#message-body')).val('');

		if (this.rwom1('.Widget #tabFans').isActive()) {
			const tabs = this.rwom1('.Widget #tabs');
			const activeTab = tabs.getParent().dom1('[data-tab-id="chat"]');

			tabs.processEvent(activeTab);
		}
	},

	onChatPrivateMessage(messageObj) {
		const cl = this.rwom1('#sidebarMain #tabChat');
		const { isBroadcaster, ...message } = messageObj;
		const name = fox.getEnv('site.alias');

		switch (message.text) {
			case this.getUserBlockToken():
				message.text = this._wrapMention(_.BLOCK_MESSAGE);
				this.inst.pauseStream();
				this.manageStatusBanners('banned');
				cl.addMessage({ ...message, isBroadcaster, name });
				break;
			case this.getUserUnblockToken():
				message.text = this._wrapMention(_.UNBLOCK_MESSAGE);
				this.inst.resumeStream();
				this.manageStatusBanners(false, true);
				cl.addMessage({ ...message, isBroadcaster, name });
				break;
			case LiveshowChatTokens.muteUser:
				message.text = this._wrapMention(_.MUTE_MESSAGE);
				this.blockedViewer = true;
				cl.addMessage({ ...message, isBroadcaster, name });
				break;
			case LiveshowChatTokens.unmuteUser:
				message.text = this._wrapMention(_.UNMUTE_MESSAGE);
				delete this.blockedViewer;
				cl.addMessage({ ...message, isBroadcaster, name });
				break;
			case this.getPrepareWebrtcTranslationToken():
				if (this._prepareWebrtcTranslationResolve) {
					this._prepareWebrtcTranslationResolve(message.dataset);
					this._prepareWebrtcTranslationResolve = null;
				}
				break;
			default:
				if (message.requestResponse) {
					if (message.mention.slice(1) === this.getMemberInfo('login')) {
						this.toggleGoPrivateBtn();
						cl.addMessage({ ...message, isBroadcaster, name });
					}
				} else {
					cl.addMessage({ ...message, isBroadcaster, name });
				}
		}

		this.toggleMessageBlock();
	},

	setChatMessage(message, p, e) {
		if (e === 'inbox_public' && message.own === this.getMemberInfo('id'))
			return this;

		if (!fox.isEmpty(message.dataset))
			message = { ...message, ...message.dataset };

		if (message.isBroadcaster === true && message.text === this.getDisconnectToken()) {
			if (this.waitForDone)
				clearTimeout(this.waitForDone);

			this.wait(_.EVENT_LIVESHOWISOVER).then(() => {
				clearTimeout(this.waitForDone);

				if (this.fullscreen === true)
					this.toggleFullscreen();

				if (message.inPrivate && message.inPrivate === this.isRequester) {
					this.manageStatusBanners('private');
					this._bindData.isRequester = true;
				} else {
					this.manageStatusBanners('done');
				}

				if (this.connectParams.private) {
					this.setChatMessage({
						type: 4,
						text: 'outro'
					});
				}

				this.blockedViewer = true;
				this.toggleMessageBlock();
				this.blockedViewer = false;

				this.leaveChat();
				this.cleanConnectParams();

				this.status = _.STATUS_DISCONNECTED;
				this.controller.stop();
				this.setLiveshowSettings();
				this.settings = {};
				this.rwom1('#sidebarMain #tabFakeChat').dispose();
				this.__privateRequestTimer = null;
			});
		} else {
			const mentionRegexp = this._getMentionRegexp();

			if ('text' in message && mentionRegexp.test(message.text)) {
				message.text = this._wrapMention(message.text);
			}

			this.rwom1('#sidebarMain #tabChat').addMessage(message);
		}

		return this;
	},

	_getMentionRegexp() {
		return new RegExp(`(@${this.getMemberInfo('login')}|@all)`);
	},

	_wrapMention(text = '') {
		const mentionRegexp = this._getMentionRegexp();

		return `<span class="ls-chat-mention">
			${text.replace(mentionRegexp, '<span class="ls-chat-mention-name">$1</span>')}
		</span>`;
	},

	toggleMessageBlock() {
		const toggle = (state, nodes = []) => {
			nodes.forEach(node => node && (node.disabled = !!state));
		}
		const nodes = [
			this.rwom1('#sidebarMain').dom1('#message-body'),
			this.rwom1('#sidebarMain').dom1(_.DOM_SELECTOR_SENDMESSAGEBTN)
		];

		if (this.isDisconnected() && !this.blockedViewer) {
			toggle(true, nodes);
		} else {
			toggle(this.blockedViewer, nodes);
		}
	},

	leaveChat() {
		const roomAlias = this.getRoomAlias();
		delete this._chatConnectionStates[roomAlias];
		this.rwom1('@root #uchatctrl').leaveRoom(roomAlias);
	}
});


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/liveshow/widget/mixins/translatorChatMethods.es.js